import { FluidIconConfig, FluidSize, FluidTheme } from '@lmig/fluid-core';
import { FunctionalComponent, h } from '@stencil/core';

import { FluidFunctionalComponentProps } from '../../../model/functional/fluid-functional-component-props.interface';
import { FluidI18nStore } from '../../../providers/fluid-i18n-provider/store/fluid-i18n.store';
import { themeVar } from '../../../utils/themes/theme.variables';

/**
 * @TODO - Move to core (Upcoming PR with documentation to move all translation options to Core)
 */
export interface FluidBadgeTranslationOptions {
  label?: string;
}

interface BadgeProps extends FluidFunctionalComponentProps {
  position?: 'before' | 'after';
  host?: any;
  config?: FluidIconConfig;
  theme?: FluidTheme;
  fluidTranslate?: FluidBadgeTranslationOptions;
  i18nStore?: FluidI18nStore;
}

/**
 * BadgeIcon - renders appropriate FLUID Icon if "iconBefore"/"iconAfter" Prop(s) used.
 */
export const BadgeIcon: FunctionalComponent<BadgeProps> = (props) => {
  const { config, position, theme } = props;

  if (!config) return;
  return (
    <span class={`badge-icon-${position}`}>
      <fluid-icon
        config={{
          ...config,
          size: config.size ?? themeVar<FluidSize>(theme, 'icons.default_size'),
          theme: config.theme ?? theme,
          overrideGlobalTheme: true,
          inline: true,
        }}
      />
    </span>
  );
};

/**
 * BadgeIconSlot - renders Icon Slot if slotted Icon is provided.
 */
export const BadgeIconSlot: FunctionalComponent<BadgeProps> = (props) => {
  const { host, position } = props;

  if (!host.querySelector(`[slot='icon-${position}']`)) return;
  return (
    <span class={`badge-icon-${position}`}>
      <slot name={`icon-${position}`} />
    </span>
  );
};

/**
 * Renders the badge label, translating where available.
 * @param props
 * @constructor
 */
export const BadgeLabel: FunctionalComponent<BadgeProps> = (
  props: BadgeProps
) => {
  const { label, fluidTranslate, i18nStore } = props;
  return (
    (label || fluidTranslate?.label) && (
      <span class='badge-label'>
        {i18nStore?.translate(fluidTranslate?.label) || label}
      </span>
    )
  );
};
